import jwtDecode from 'jwt-decode';
import { TOKEN_KEY } from '@/constants/auth';

export function getToken() {
  return window.localStorage.getItem(TOKEN_KEY);
}

export function setToken(token: string) {
  window.localStorage.setItem(TOKEN_KEY, token);
}

export function removeToken() {
  window.localStorage.removeItem(TOKEN_KEY);
}

export function isJwtTokenExpired(jwtToken: string) {
  const { exp } = jwtDecode(jwtToken);

  return Date.now() >= exp * 1000;
}

export function getJwtTokenIfNotExpired() {
  const token = getToken();

  if (!token || isJwtTokenExpired(token)) {
    return null;
  }

  return token;
}
